var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22.073,
    viewBox: "0 0 23 22.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-9.2 -9.436)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 6.905,
    height: 1.691,
    transform: "translate(17.148 16.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 10.851,
    height: 1.691,
    transform: "translate(17.148 20.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Compound_Path",
    "data-name": "Compound Path",
    d: "M31.72,9.535a.87.87,0,0,0-.9.136L28.45,11.683l-2.368-2.04a.869.869,0,0,0-1.127,0l-2.368,2.04L20.22,9.644a.869.869,0,0,0-1.127,0l-2.368,2.04L14.358,9.671a.87.87,0,0,0-.917-.133.814.814,0,0,0-.492.759v14.5h-2.9a.831.831,0,0,0-.846.816v1.985a3.954,3.954,0,0,0,3.89,3.916H28.168A3.962,3.962,0,0,0,32.2,27.62V10.3A.813.813,0,0,0,31.72,9.535ZM30.508,27.62a2.355,2.355,0,0,1-4.707,0V25.607a.831.831,0,0,0-.846-.816H14.639v-12.7L16.19,13.4a.869.869,0,0,0,1.127,0l2.368-2.04,2.339,2.04a.869.869,0,0,0,1.127,0l2.368-2.04,2.368,2.04a.869.869,0,0,0,1.127,0l1.522-1.305Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingPlan);
export default __webpack_public_path__ + "static/media/pricing_plan.37fb93d6.svg";
export { ForwardRef as ReactComponent };